import { useReinstallService } from './handlers/install'
import FormD4Sign from './Form/FormD4sign'
import { assoc, compose } from 'ramda'
import { pick } from 'lodash'

export const D4SIGN = {
  key: 'd4sign',
  onReinstall: useReinstallService,
  Form: FormD4Sign,
  SCOPE: []
}

export default D4SIGN
